import React from 'react';

import { HYPHEN_CHARACTER } from 'src/constants/Generals';
import styles from './DefaultValue.scss';

const DefaultValue = () => <div className={styles.initialValues}>{HYPHEN_CHARACTER}</div>;

export default DefaultValue;